export default "__VITE_ASSET__9bc3b8c8__"